import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import L from "leaflet";
import markerIcon2xUrl from "leaflet/dist/images/marker-icon-2x.png";
import markerIconUrl from "leaflet/dist/images/marker-icon.png";
import markerShadowUrl from "leaflet/dist/images/marker-shadow.png";

import { App } from "./App";
import { AuthProvider } from "./auth/AuthProvider";
import { getQueryClient } from "./lib/queryClient";
import "leaflet/dist/leaflet.css";
import "./styles.css";
import "./styles/design-tokens.css";
import "./styles/components.css";
import "./styles/layout.css";
import "./styles/landing-page.css";
import "./styles/clients-page.css";
import "./styles/client-datasets-page.css";
import "./styles/dataset-detail-page.css";
import "./styles/admin-access-page.css";
import "./styles/data-management-page.css";

L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2xUrl,
  iconUrl: markerIconUrl,
  shadowUrl: markerShadowUrl,
});

const root = document.getElementById("root");

if (!root) {
  throw new Error("Root element not found");
}

const queryClient = getQueryClient();

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
